import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/v1/product-pallet-foc', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/v1/product-pallet-foc', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

// export const update = data => {
//   return httpClient
//     .post('/api/v1/product-pallet-foc/update-data', data)
//     .then(response => Promise.resolve(response.data))
//     .catch(error => Promise.reject(error.response.data))
// }

export const product = (Options = {}) => {
  return httpClient
    .get('/api/v1/product-pallet-foc/products', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default { get, store, product }